export const appConfig = {
  name: 'Pilot',
  version: '1.0.0',
  description: 'Country Chicken Co',
  
  // API Configuration
  api: {
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
    timeout: 30000,
  },
  
  // Navigation Links
  navigation: {
    main: [
      { title: 'Home', path: '/', public: true },
      { title: 'Dashboard', path: '/dashboard', public: false },
    ],
    admin: [
      { title: 'Dashboard', path: '/admin/dashboard', public: false },
      { title: 'Orders', path: '/admin/orders', public: false },
      {
        title: 'Delivery',
        path: '/admin/delivery',
        public: false,
        children: [
          { title: 'Orders', path: '/admin/delivery/orders', public: false },
          { title: 'Routes', path: '/admin/delivery/routes', public: false },
          { title: 'Riders', path: '/admin/delivery/riders', public: false },
          { title: 'Live Tracking', path: '/admin/delivery/live-tracking', public: false }
        ]
      },
      {
        title: 'Reports',
        path: '/admin/reports',
        public: false,
        children: [
          { title: 'Sales Report', path: '/admin/reports/sales', public: false },
          { title: 'Delivery Report', path: '/admin/reports/delivery', public: false }
        ]
      },
    ],
    superAdmin: [
      { 
        title: 'Stores', 
        path: '/super-admin/stores', 
        public: false, 
        children: [
          { title: 'Add Store', path: '/super-admin/stores/add', public: false },
          { title: 'Store List', path: '/super-admin/stores/list', public: false },
          { title: 'Delivery Pods', path: '/super-admin/stores/pods', public: false }
        ]
      },
      {
        title: 'Customers',
        path: '/super-admin/users',
        public: false,
        children: [
          { title: 'Add User', path: '/super-admin/users/add', public: false },
          { title: 'Customer List', path: '/super-admin/users/list', public: false },
          { title: 'Customer Segmentation', path: '/super-admin/users/segmentation', public: false }
        ]
      },
      {
        title: 'Orders',
        path: '/super-admin/orders',
        public: false,
        children: [
          { title: 'Order List', path: '/super-admin/orders/list', public: false },
          { title: 'Manual Order Creation', path: '/super-admin/orders/manual-create', public: false }
        ]
      },
      {
        title: 'Products',
        path: '/super-admin/products',
        public: false,
        children: [
          { title: 'Categories', path: '/super-admin/categories/manage', public: false },
          { title: 'Add Product', path: '/super-admin/products/add', public: false },
          { title: 'Product List', path: '/super-admin/products/list', public: false },
          { title: 'Stock', path: '/super-admin/products/stock', public: false }
        ]
      },
      {
        title: 'Coupons',
        path: '/super-admin/coupons',
        public: false,
        children: [
          { title: 'Add Coupon', path: '/super-admin/coupons/add', public: false },
          { title: 'Coupon List', path: '/super-admin/coupons/list', public: false }
        ]
      },
      {
        title: 'Delivery',
        path: '/super-admin/delivery',
        public: false,
        children: [
          { title: 'Time Slots', path: '/super-admin/delivery/time-slots', public: false },
          { title: 'Orders', path: '/super-admin/delivery/orders', public: false },
          { title: 'Routes', path: '/super-admin/delivery/routes', public: false },
          { title: 'Riders', path: '/super-admin/delivery/riders', public: false },
          { title: 'Live Tracking', path: '/super-admin/delivery/live-tracking', public: false },
          { title: 'Rider App Updates', path: '/super-admin/delivery/rider-app-updates', public: false }
        ]
      },
      {
        title: 'Reports',
        path: '/super-admin/reports',
        public: false,
        children: [
          { title: 'Sales Report', path: '/super-admin/reports/sales', public: false },
          { title: 'Delivery Report', path: '/super-admin/reports/delivery', public: false },
          { title: 'Rider Route Distance', path: '/super-admin/reports/rider-route-distance', public: false },
          { title: 'Order Status Dashboard', path: '/super-admin/reports/order-status', public: false },
          { title: 'On-Time Delivery Status', path: '/super-admin/reports/order-ontime', public: false }
        ]
      },
      {
        title: 'App & Website',
        path: '/super-admin/app-website',
        public: false,
        children: [
          { title: 'Banners', path: '/super-admin/app-website/banners', public: false },
          { title: 'Popup Banners', path: '/super-admin/app-website/popup-banners', public: false },
          { title: 'Cart Recommendations', path: '/super-admin/app-website/cart-recommendations', public: false },
          { title: 'Notifications', path: '/super-admin/app-website/notifications', public: false }
        ]
      },
      {
        title: 'Others',
        path: '/super-admin/others',
        public: false,
        children: [
          { title: 'Focus Errors', path: '/super-admin/focus-errors', public: false }
        ]
      }
    ]
  },
  
  // Footer Links
  footer: {
    links: [
      { title: 'Privacy Policy', path: '/privacy' },
      { title: 'Terms of Service', path: '/terms' },
      { title: 'Contact Us', path: '/contact' },
      { title: 'About', path: '/about' },
    ]
  },
  
  // Features
  features: {
    authentication: true,
    roleBasedAccess: true,
    darkMode: true,
  },
  
  // Storage Keys
  storage: {
    token: 'pilot_auth_token',
    user: 'pilot_user_data',
  }
}; 